import { isTimestampBefore } from 'utils/datetime';

/**
 * @typedef {object} DateRangeSelectionState
 * @property {Date | null} startDate
 * @property {Date | null} endDate
 * @property {boolean} isInSelection
 */

/** Empty selection: nothing picked yet. */
export const EMPTY_SELECTION = {
	startDate: null,
	endDate: null,
	isInSelection: false,
};

/**
 * Advance the calendar selection state machine given the currently picked date.
 *
 * Rules:
 * - No `startDate` yet → set it and enter selection mode.
 * - `startDate` set, no `endDate`:
 *   - If `date` is later than or equal to `startDate` → commit `endDate`, exit selection.
 *   - Otherwise → reset selection to start at the newly-picked date, no `endDate`.
 * - Both dates set → reset to a fresh selection starting at `date`.
 *
 * @param {DateRangeSelectionState} state
 * @param {Date} date
 * @returns {DateRangeSelectionState}
 */
export const reduceSelection = (state, date) => {
	const { startDate, endDate } = state;

	if (startDate === null) {
		return { startDate: date, endDate: null, isInSelection: true };
	}

	if (endDate === null) {
		if (isTimestampBefore(startDate, date) || startDate === date) {
			return { startDate, endDate: date, isInSelection: false };
		}
		return { startDate: date, endDate: null, isInSelection: true };
	}

	return { startDate: date, endDate: null, isInSelection: true };
};
